module.exports = __webpack_public_path__ + "static/media/6_Prepare-Existing-Transformer-Cable-WireOut.e1c9e570.svg";